<template>
  <div>
    <v-container :class="containerClass" class="input-text-size pa-1">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left input-text-size dialog-payment-details-payment-type"
              id="dialogPaymentDetailsPaymentType" style="width: 24em;">
                Payment Info
              </th>
              <th class="text-left input-text-size" v-if="isForteGateway">Status</th>
              <th class="text-left input-text-size"></th>
              <th class="text-left input-text-size"></th>
              <th class="text-left input-text-size"></th>
              <th class="text-left input-text-size">
                <v-btn
                :class="handlePlusClass() + ' dialog-payment-details-plus-btn'"
                id="dialogPaymentDetailsPlusBtn"
                  color="primary"
                  fab icon x-small
                  @click="addOne(); notifyPaymentFieldActivity();"
                  :autofocus="true"
                >
                  <v-icon :class="handlePlusClass()">
                    {{icons.mdiPlus}}
                  </v-icon>
                </v-btn>
              </th>
              <th class="text-left"
              v-if="hideUnhidePaymentAndBatchPaymentDetails.showBatchPaymentUtility">
                <v-btn
                  class="mx-2 edit-batch-payment-details-btn input-text-size"
                  color="primary"
                  small
                  @click="emitEditBatchPaymntItem"
                >
                  Edit Batch Payment
                </v-btn>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in editedItem"
              :key="index"
            >
              <td>
                <v-select
                  v-model="item.paymentType"
                  label="Payment Type"
                  :items="filteredPaymentTypes"
                  :rules="reqdSelectValidation"
                  :readonly="isReadOnly"
                  item-text="description"
                  item-value="name"
                  class="tmc-payment-details-paymentType input-text-size
                  daialog-payment-details-payment-type"
                  id="dialogPaymentDetailsPaymentType"
                  @change="somethingChanged(); onChangePaymentType(index);
                  onChangeCcTypeOrAmount(item, index); notifyPaymentFieldActivity();"
                  ref="paymentTypeRef"
                  ref-in-for
                  dense
                  single-line
                  ></v-select>
              </td>
              <td>
                <v-chip
                  v-if="shouldWarnUnprocessedCC(item, index)"
                  small
                  color="warning"
                  text-color="white"
                >
                  Not Processed
                </v-chip>
                <v-chip
                  v-else-if="item.ccProcessed"
                  small
                  color="success"
                  text-color="white"
                >
                  Processed
                </v-chip>
              </td>
              <td v-if="item.paymentType === 'CHECK'">
                <v-text-field
                  dense
                  single-line
                  hint="Check Number"
                  persistent-hint
                  :readonly="isReadOnly"
                  v-model="item.checkNumber"
                  class="tmc-payment-details-checkNumber input-text-size
                  dialog-payment-details-check-number"
                  id="dialogPaymentDetailsCheckNumber"
                  @blur="somethingChanged"
                ></v-text-field>
              </td>
              <td v-if="item.paymentType !== 'EFT' && item.paymentType !== 'CREDIT'
              && item.paymentType !== 'CHECK'"></td>
              <td v-if="item.paymentType === 'EFT'">
                <v-select
                  dense
                  single-line
                  hint="EFT Type"
                  persistent-hint
                  v-model="item.eftType"
                  v-if="item.paymentType === 'EFT'"
                  item-text="description"
                  item-value="name"
                  class="tmc-payment-details-eftType input-text-size
                  dialog-payment-details-eft-type"
                  id="dialogPaymentDetailsEftType"
                  :items="cmnEnums.cmnEFTTypes"
                  :readonly="isReadOnly"
                  @blur="somethingChanged"
                ></v-select>
              </td>
              <td v-if="item.paymentType === 'CREDIT' && !isPayrix && !isForte2">
                <v-select
                  v-model="item.creditType"
                  hint="CC Type"
                  persistent-hint
                  item-text="description"
                  item-value="name"
                  class="tmc-payment-details-creditType input-text-size
                  dialog-payment-details-credit-type"
                  id="dialogPaymentDetailsCreditType"
                  dense
                  single-line
                  :items="cmnEnums.cmnCardTypes"
                  :readonly="isReadOnly"
                  @blur="somethingChanged"
                ></v-select>
              </td>
              <td>
                <v-text-field
                  dense
                  single-line
                  :hint="settingAmountPlaceHolder(item)"
                  :readonly="isReadOnly"
                  persistent-hint
                  v-model="item.amount"
                  class="tmc-payment-details-amount input-text-size dialog-payment-details-amount"
                  id="dialogPaymentDetailsAmount"
                  @blur="amountFrtBfrSomethingChangedCall(item, index);
                  onChangeCcTypeOrAmount(item, index); notifyPaymentFieldActivity();"
                  @keydown.enter="somethingChanged"
                  @keydown="paymentDetailsShortcutHandler(
                            $event, item.paymentType, 'amount', index);"
                ></v-text-field>
              </td>
              <td>
                <v-text-field
                  dense
                  single-line
                  hint="Paid By"
                  persistent-hint
                  v-model="item.paidBy"
                  class="tmc-payment-details-paidBy input-text-size dialog-payment-details-paid-by"
                  id="dialogPaymentDetailsPaidBy"
                  :readonly="isReadOnly"
                  @blur="somethingChanged(); notifyPaymentFieldActivity();"
                  @keydown.enter="somethingChanged(); notifyPaymentFieldActivity();"
                  @keydown="paymentDetailsShortcutHandler(
                          $event, item.paymentType, 'paidBy', index);"
                  v-uppercase=globalSettingItem.conEverythingToCaps
                ></v-text-field>
              </td>
              <td v-if="abilityToAddMtgCodePayment">
                <!-- The saved code has to be handed back in, or reopening a payment shows an
                     empty box beside a filled-in Paid By. It never mattered before: the code
                     was not stored, so there was nothing to show. -->
                <CommonDropDowns :isItMtgCode=true :allowTypedMtgCode=true
                :mtgCodeValue="item.mtgCode || ''"
                @change="val=>dataFromCommonDropDowns(val, index)"
                />
              </td>
              <td v-if="item.paymentType === 'CREDIT' && !item.ccProcessed && !isPayrix && !isForte2">
                <!-- showFortePaymentBtn: shared gate for the gateway "Proceed to pay"
                     buttons, driven by the legacy Forte1 isRequiredForte config (not
                     specific to this button). Full explanation on the computed below. -->
                <ForteTaxPayment
                  v-if="showFortePaymentBtn && forteActiveIndex === index"
                  @forteResponse="forteResponse"
                  :taxPaymentForte="taxPaymentRecord"
                />
              </td>
              <td v-if="item.paymentType === 'CREDIT' && isPayrix">
                <v-btn class="input-text-size dialog-payment-details-credit-btn"
                id="dialogPaymentDetailsCreditBtn" dense
                  color="primary" @click="handlePayrix(item, index)">
                  Proceed to pay
                </v-btn>
              </td>
              <td v-if="(item.paymentType === 'CREDIT' || item.paymentType === 'ECHECK') && isForte2">
                <v-btn class="input-text-size dialog-payment-details-credit-btn"
                id="dialogPaymentDetailsForte2CreditBtn" dense
                  color="primary" @click="handleForte2(item, index)">
                  Proceed to pay
                </v-btn>
              </td>
              <td v-if="isTotal">
                <v-icon
                  small class="mr-2 tmc-payment-details-delete-icon"
                  tabindex="-1"
                  @click="removeOne(item)"
                >
                  {{icons.mdiDelete}}
                </v-icon>
              </td>
            </tr>
            <tr v-if="isTotal"
            class="blue--text tmc-payemnt-details-total-amount input-text-size
            dialog-payment-details-total-amount"
            id="dialogPaymentDetailsTotalAmount">
            <td colspan="5" id="total-trans-amount"
              v-if="((editedItem || []).length) !== 0">
              <span>Total of Payments : ${{ amountFormat(totalPaymentAmt) }}</span>
              <span class="ml-5 dialog-payment-details-remaining-amount"
              id="dialogPaymentDetailsRemainingAmount">{{ amountRemainingLabel }} :
                <span style="color: red;">${{ amountFormat(amountRemainingDisplay) }}</span>
              </span>
              <span colspan="1" id="total-trans-amount" v-if="showPennyRound">
                <v-btn class="ml-5 dialog-payment-details-penny-round-btn"
                id="dialogPaymentDetailsPennyRoundBtn"
                small color="primary" :disabled="disableOverUnderPay"
                @click="$emit('pennyRoundClicked')">Penny Round</v-btn>
              </span>
              <span colspan="1" id="total-trans-amount" v-if="showOverUnder">
                <v-btn class="ml-5 dialog-payment-details-over-under-btn"
                id="dialogPaymentDetailsOverUnderBtn"
                small color="primary" :disabled="disableOverUnderPay"
                @click="overUnderPayment">Over/Under Payment</v-btn>
              </span>
              <span v-if="showOverpayment">
                <v-btn class="ml-5"
                id="dialogPaymentDetailsOverpaymentBtn"
                small color="blue darken-1" dark
                @click="$emit('overpaymentClicked')">
                  {{ overpaymentAmt ? 'Update Overpayment' : 'Overpayment' }}
                </v-btn>
                <span class="ml-2 black--text">${{ amountFormat(Math.abs(amountRemaining)) }}</span>
              </span>
              <span v-else-if="overpaymentAmt" class="ml-3 font-weight-bold black--text">
                &#10003; Overpayment Recorded: ${{ amountFormat(overpaymentAmt) }}
              </span>
            </td>
          </tr>
        </tbody>
      </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
import {
  mdiPlus,
  mdiDelete,
} from '@mdi/js';
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import ForteTaxPayment from '../../../common/ForteTaxPayment.vue';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import '../../../../assets/style.css';

import {
  amountFormat,
  amountToNumber,
  isTabOrPlus,
  checkStringEmptiness,
  isInsert,
} from '../../../../util/shared/vue-global';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';

const defaultItem = {
  paymentType: '',
  amount: 0,
  paidBy: '',
  ccProcessed: false,
};
const isCreditItem = (item) => (item.paymentType === 'CREDIT');

export default {
  mixins: [GlobalToCaps],
  name: 'PaymentDetailsComponent',
  components: {
    ForteTaxPayment,
    CommonDropDowns,
  },
  created() {
    window.addEventListener('keydown', this.paymentDetailsShortcutHandler);
    this.onLoadDialogBox();
  },
  destroyed() {
    window.removeEventListener('keydown', this.paymentDetailsShortcutHandler);
  },
  props: {
    showOverUnder: {
      type: Boolean,
      default: false,
    },
    // Cash change can no longer be handed back in pennies, so a cash total that is not on a
    // nickel offers this instead - see pennyRoundClicked in paymentDialog.vue.
    showPennyRound: {
      type: Boolean,
      default: false,
    },
    showOverpayment: {
      type: Boolean,
      default: false,
    },
    overpaymentAmt: {
      type: Number,
      default: 0,
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    whomString: {
      type: String,
      default: '',
    },
    cmnEnums: {
      type: Object,
      default: () => ({}),
    },
    paymentTypeFlags: {
      type: Object,
      default: () => ({}),
    },
    defaultPaymentType: {
      type: Object,
      default: () => ({}),
    },
    defaultForteConfig: {
      type: Object,
      default: () => ({}),
    },
    taxPaymentRecord: {
      type: Object,
      default: () => ({}),
    },
    amount: [Number, String],
    isDialogBoxVisible: {
      type: Boolean,
      default: false,
    },
    isTotal: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    toolbarTitle: {
      type: String,
      default: 'Items',
    },
    transactionId: {
      type: String,
      default: null,
    },
    paymentDetailsFlags: {
      type: Object,
      default: () => ({}),
    },
    programType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    icons: {
      mdiPlus,
      mdiDelete,
    },
    forteActiveIndex: -1,
    renderForteComponentFlag: false,
    totalAmount: 0,
    convenienceFee: 0,
    trigerIndexMtgcode: 0,
  }),
  watch: {
    isDialogBoxVisible() {
      if (this.isDialogBoxVisible) {
        this.onLoadDialogBox();
      } else {
        this.renderForteComponentFlag = false;
      }
    },
    isItPayRecordNCounter() {
      this.addOne();
    },
    payrixSuccessFlag(newVal) {
      // Only act on a successful charge. A `false` here is the re-arm reset fired by
      // handlePayrix (or the post-save reset), NOT a real success — bailing on it stops
      // Boolean(false) from coercing the active row's ccProcessed back off. Mirrors the
      // forte2SuccessFlag guard below.
      if (!newVal) return;
      const itemIndex = Number(this.payrixActiveItemIndex);
      if (!Number.isInteger(itemIndex) || itemIndex < 0 || itemIndex >= this.editedItem.length) {
        console.warn('PaymentDetails: Invalid item index for payment processing', itemIndex);
        return;
      }
      const updatedItems = [...this.editedItem];
      const targetItem = updatedItems[itemIndex];
      if (!targetItem) {
        console.warn('PaymentDetails: Item not found at index', itemIndex);
        return;
      }
      updatedItems[itemIndex] = {
        ...targetItem,
        ccProcessed: Boolean(newVal),
      };
      this.$emit('input', updatedItems);
    },
    forte2SuccessFlag(newVal) {
      // Only act on a successful charge. Guarding `!newVal` (not just null/undefined) prevents a
      // reset's `false` event from flipping ccProcessed back off: Number(null) coerces to 0, a
      // valid index, which would un-process row 0.
      if (!newVal) return;
      const itemIndex = Number(this.forte2ActiveItemIndex);
      if (!Number.isInteger(itemIndex) || itemIndex < 0 || itemIndex >= this.editedItem.length) {
        return;
      }
      const updatedItems = [...this.editedItem];
      const targetItem = updatedItems[itemIndex];
      if (!targetItem) {
        return;
      }
      updatedItems[itemIndex] = {
        ...targetItem,
        ccProcessed: Boolean(newVal),
      };
      this.$emit('input', updatedItems);
    },
  },
  computed: {
    ...mapGetters('user', ['getSettings']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      miscSettingItem: (state) => state.SystemConfig.miscSettingItem || {},
      taxMortgageCodes: (state) => state.shared.taxMortgageCodesShared.taxMortgageCodes,
      isItPayRecordNCounter: (state) => state.tax.taxPayment
        .paymentShotCutStore.isItPayRecordNCounter || 0,
      paymentAddIconStatus: (state) => state.tax.taxPayment
        .paymentShotCutStore.paymentAddIconStatus || false,
      disableOverUnderPay: (state) => state.tax.taxPayment.disableOverUnderPay,
      odSettingItem: (state) => state.SystemConfig.odSettingItem,
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      abilityToAddMtgCodePayment() {
        if (this.paymentSettingItem.abilityToAddMtgCodePayment) {
          return this.paymentSettingItem.abilityToAddMtgCodePayment;
        }
        return false;
      },
      payrixSuccessFlag: (state) => state.common.payrixPayment.paymentSuccessFlag,
      payrixActiveItemIndex: (state) => state.common.payrixPayment.activeItemIndex,
      forte2SuccessFlag: (state) => state.common.forte2Payment.paymentSuccessFlag,
      forte2ActiveItemIndex: (state) => state.common.forte2Payment.activeItemIndex,
    }),
    isPayrix() {
      const excludedPrograms = ['MTG', 'MISC', 'OD'];
      const program = (this.programType || '').toUpperCase();
      const odSettings = this.odSettingItem;
      const paymentSettings = this.paymentSettingItem;
      const isAllowedProgram = !excludedPrograms.includes(program);
      const isPayrixGateway = odSettings.selectedGateway === 'payrix';
      const hasConfig = !!paymentSettings.payrixPublicKey && !!paymentSettings.posMerchantId;
      const result = isAllowedProgram && isPayrixGateway && hasConfig;

      return result;
    },

    isForte2() {
      const excludedPrograms = ['MTG', 'MISC', 'OD'];
      const program = (this.programType || '').toUpperCase();
      const odSettings = this.odSettingItem;
      const paymentSettings = this.paymentSettingItem;
      const isAllowedProgram = !excludedPrograms.includes(program);
      const isForte2Gateway = odSettings.selectedGateway === 'forte2';
      const hasConfig = !!odSettings.forte2ApiAccessId
        && !!odSettings.forte2ApiSecureKey
        && !!paymentSettings.forte2ApiLoginId;
      const result = isAllowedProgram && isForte2Gateway && hasConfig;

      return result;
    },

    filteredPaymentTypes() {
      return this.cmnEnums.cmnPaymentTypes || [];
    },

    isForte() {
      const settings = this.odSettingItem;
      const isForteGateway = settings.selectedGateway === 'forte-pay';
      const hasConfig = !!settings.apiAccessId && !!settings.apiSecureId;
      const result = isForteGateway && hasConfig;

      return result;
    },

    isForteGateway() {
      const settings = this.odSettingItem;
      const isForteGateway = settings.selectedGateway === 'forte-pay';
      return isForteGateway;
    },

    editedItem: {
      get() {
        const newVal = JSON.parse(JSON.stringify(this.value)) || [];
        const updatedValue = newVal.map(this.loadInitialValues);
        return updatedValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    amountRemaining() {
      let totalRemainingPaymentAmount = amountToNumber(this.amount);
      for (let i = 0; i < (this.editedItem || []).length; i += 1) {
        totalRemainingPaymentAmount -= amountToNumber(this.editedItem[i].amount);
      }
      this.$emit('totalRemainingPaymentAmount', totalRemainingPaymentAmount);
      return totalRemainingPaymentAmount;
    },
    hasCashPayment() {
      return (this.editedItem || []).some((item) => item.paymentType === 'CASH');
    },
    // An overpayment drives `amountRemaining` negative. Rather than show a minus
    // sign under "Remaining Amount Due", flip the label to "Change Due" - the
    // same wording as the Change Due field on paymentDialog.vue - and show the
    // figure as a positive. amountToNumber truncates to cents first so float
    // dust on an exact payment (-1e-13) reads as -0, not an overpayment.
    // Only cash hands physical change back, so the flip is gated on a CASH row
    // being present, matching the `isThereCashPay` gate on paymentDialog.vue.
    // A non-cash overpayment is an over/under or an overpayment record, not
    // change, so it keeps reading as a negative Remaining Amount Due.
    isChangeDue() {
      return this.hasCashPayment && amountToNumber(this.amountRemaining) < 0;
    },
    amountRemainingLabel() {
      return this.isChangeDue ? 'Change Due' : 'Remaining Amount Due';
    },
    amountRemainingDisplay() {
      return this.isChangeDue
        ? Math.abs(amountToNumber(this.amountRemaining))
        : this.amountRemaining;
    },
    totalPaymentAmt() {
      let totalPaymentAmount = 0;
      for (let i = 0; i < (this.editedItem || []).length; i += 1) {
        totalPaymentAmount += amountToNumber(this.editedItem[i].amount);
      }
      this.$emit('totalPaymentAmount', totalPaymentAmount);
      return totalPaymentAmount;
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    totalCreditAmount() {
      let totalCrediAmtSum = 0.00;
      (this.editedItem || []).forEach((item) => {
        if (item.paymentType === 'CREDIT') {
          totalCrediAmtSum += amountToNumber(item.amount);
        }
      });
      return totalCrediAmtSum;
    },
    // Shared visibility gate for the gateway "Proceed to pay" buttons — NOT
    // specific to Forte1, despite the name. Driven entirely by legacy Forte1
    // config:
    //   - renderForteComponentFlag: flips true once the payment dialog loads.
    //   - defaultForteConfig.isRequiredForte: a Forte1 enablement flag.
    // Consequence: any gateway button gated on this stays hidden unless the
    // legacy Forte1 `isRequiredForte` flag is turned on.
    showFortePaymentBtn() {
      return this.renderForteComponentFlag && this.defaultForteConfig.isRequiredForte;
    },
    enableAutofillMiscReceivedOf() {
      return this.miscSettingItem.enableAutofillofPaidByfromReceivedOf;
    },
    isTransactionId() {
      return !checkStringEmptiness(this.transactionId);
    },
    isAmountRemainingZero() {
      return amountToNumber(this.amountRemaining) === 0;
    },
    hideUnhidePaymentAndBatchPaymentDetails() {
      const flags = {
        canAddPaymentDetails: false,
        showBatchPaymentUtility: false,
      };
      if (Object.keys(this.paymentDetailsFlags).length > 0) {
        if (this.paymentDetailsFlags.isCallForBatchPayment && this.isTransactionId) {
          flags.showBatchPaymentUtility = true;
        } else if (this.paymentDetailsFlags.isCallForNormalPayment && !this.isTransactionId) {
          flags.canAddPaymentDetails = !this.isAmountRemainingZero;
        }
      } else {
        flags.canAddPaymentDetails = !this.isAmountRemainingZero;
      }
      return flags;
    },
    containerClass() {
      return this.getSettings.lightdark === 'light' ? 'grey lighten-5 mb-2' : '';
    },
  },
  mounted() {
    this.setConfigData({});
  },
  methods: {
    ...mapActions('ForteService', [
      'fetchForteConfig',
      'setForteResponse',
    ]),
    ...mapActions('common/payrixPayment', [
      'setPayrixPaymentData',
      'setPayrixPaymentType',
      'setPaymentContext',
      'toggleDialog',
      'setPaymentSuccessFlag',
      'setActiveItemIndex',
      'setLastSavedPaymentItem',
      'clearCapturedCCPayments',
    ]),
    ...mapActions('common/forte2Payment', {
      setForte2PaymentData: 'setForte2PaymentData',
      setForte2PaymentType: 'setForte2PaymentType',
      toggleForte2Dialog: 'toggleDialog',
      setForte2ActiveItemIndex: 'setForte2ActiveItemIndex',
      setForte2PaymentSuccessFlag: 'setForte2PaymentSuccessFlag',
      clearCapturedForte2Payments: 'clearCapturedForte2Payments',
    }),
    ...mapMutations('ForteService', [
      'setConfigData',
      'setFortePaymentSuccessFlag',
      'setForteIndex',
      'clearCapturedForteResponses',
    ]),
    amountFormat,
    amountToNumber,
    // The dropdown labels a code "<code>  - <company>". Paid By wants the company on its own,
    // which is what keying the code filled in on the old system.
    mtgCoNameFromListItem(item) {
      const label = `${(item || {}).name || ''}`;
      const separator = label.indexOf(' - ');
      return (separator === -1 ? label : label.slice(separator + 3)).trim();
    },
    dataFromCommonDropDowns(val, index) {
      this.editedItem[index].mtgCode = val;
      const selected = (this.taxMortgageCodes || []).find((item) => val === item.value);
      // A code that resolved to nothing leaves Paid By alone: it is either a code this screen
      // has no record for, or text the user typed for themselves, and neither is a reason to
      // wipe out what is in the field. Clearing the dropdown does still clear it.
      if (val && !selected) {
        this.$emit('input', this.editedItem);
        return;
      }
      // Code-filled, so the v-uppercase directive on the Paid By input never fires for it - it
      // only converts what the user types. Convert here so the screen matches what the server
      // will store.
      this.editedItem[index].paidBy = this.toCapsIfEnabled(
        val ? this.mtgCoNameFromListItem(selected) : null,
      );

      this.$emit('input', this.editedItem);
    },
    loadInitialValues(item) {
      const itemList = { ...item };
      const defaultToCheck = (this.paymentSettingItem || {}).defaultPaymentTypeCheck || false;

      // if this 'defaultPaymentTypeCheck' is enabled in setting, make check as default
      if ((!itemList.paymentType) && defaultToCheck) itemList.paymentType = 'CHECK';
      return {
        ...defaultItem,
        ...itemList,
        // paymentType,
        amount: amountFormat(amountToNumber(itemList.amount)),
        ccProcessed: Boolean(itemList.ccProcessed),
      };
    },
    addOne() {
      const defaultToCheck = (this.paymentSettingItem || {}).defaultPaymentTypeCheck || false;
      let paymentType = '';

      // if this 'defaultPaymentTypeCheck' is enabled in setting, make check as default
      if (defaultToCheck) paymentType = 'CHECK';
      this.$emit('input', [
        ...this.editedItem,
        {
          ...defaultItem,
          paymentType,
        },
      ]);
      return true;
    },
    removeOne(item) {
      this.$emit('input', [
        ...this.editedItem.filter((candidate) => item !== candidate),
      ]);
    },
    emitEditBatchPaymntItem() {
      this.$emit('emitEditBatchPaymntItem');
    },
    amountFrtBfrSomethingChangedCall(item, index) {
      this.editedItem[index].amount = amountToNumber(item.amount);
      this.somethingChanged();
    },
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
    // Notifies the parent (paymentDialog) so any pending "Add Tax Details" row that
    // hasn't been committed yet gets added to the payment list before the clerk
    // starts filling in Payment Info fields.
    notifyPaymentFieldActivity() {
      this.$emit('paymentFieldActivity');
    },
    settingAmountPlaceHolder(item) {
      if (item && item.paymentType) {
        if (item.paymentType === 'CASH') {
          return 'Amount';
        }
        if (item.paymentType === 'CREDIT' || item.paymentType === 'EFT') {
          return 'Amount';
        }
        if (item.paymentType === 'CHECK') {
          return 'Amount';
        }
      }
      return '';
    },
    autoFillCheckPaidBy(index) {
      if (this.editedItem[index].paymentType && this.editedItem[index].paymentType === 'CHECK' && this.enableAutofillMiscReceivedOf) {
        // Code-filled from Received Of - see dataFromCommonDropDowns above.
        this.editedItem[index].paidBy = this.toCapsIfEnabled(this.whomString || '');
      }
      return this.editedItem;
    },
    paymentDetailsShortcutHandler(e, paymentType, fieldName, index) {
      let totalAmount = 0;
      if ((isTabOrPlus(e) || isInsert(e))
        && (this.isPaymentTypeSelected(paymentType, fieldName))) {
        if ((index + 1) === (this.editedItem || []).length) {
          for (let i = 0; i < (this.editedItem || []).length; i += 1) {
            totalAmount += amountToNumber(this.editedItem[i].amount);
            this.somethingChanged();
            const amountDifference = amountToNumber(this.amount) - totalAmount;
            if ((Math.sign(amountToNumber(this.amount)) === 1) && (amountDifference > 0)) {
              this.addOne();
            } else if ((Math.sign(amountToNumber(this.amount)) === -1) && (amountDifference < 0)) {
              this.addOne();
            }
          }
        }
      }
    },
    isPaymentTypeSelected(paymentType, fieldName) {
      return ((paymentType === 'CHECK' && fieldName === 'paidBy')
      || (paymentType === 'CASH' && fieldName === 'paidBy')
      || (paymentType === 'EFT' && fieldName === 'paidBy')
      || (paymentType === 'CREDIT' && fieldName === 'paidBy'));
    },
    onChangePaymentType(index) {
      this.autoFillCheckPaidBy(index);
      this.assignDefaultPaymentType(index);
    },
    assignDefaultPaymentType(index) {
      if (this.paymentTypeFlags && this.paymentTypeFlags.eftPaymentType && this.editedItem[index].paymentType === 'EFT') {
        this.editedItem[index].eftType = (this.defaultPaymentType.eftPaymentType).toUpperCase();
      }
      if (this.paymentTypeFlags && this.paymentTypeFlags.ccPaymentType && this.editedItem[index].paymentType === 'CREDIT') {
        this.editedItem[index].creditType = (this.defaultPaymentType.ccPaymentType).toUpperCase();
      }
    },
    forteResponse(response) {
      if (response.event === 'success') {
        this.setFortePaymentSuccessFlag(true);
        this.setForteResponse(response);
      }
      this.$emit('forteResponse', response);
    },
    onLoadDialogBox() {
      const isCreditItemAvailable = (this.editedItem || []).find((item) => isCreditItem(item));
      if (isCreditItemAvailable) {
        this.fetchForteConfiguration(isCreditItemAvailable);
      }
    },
    onChangeCcTypeOrAmount(item, index) {
      if (isCreditItem(item, index)) {
        this.fetchForteConfiguration(item);
        // Starting a fresh payment's FIRST card? Drop any Forte responses captured for a
        // prior (e.g. abandoned) payment so they can't leak onto this one. Once a card on
        // this payment has been processed, keep them so earlier cards' captures survive to
        // be saved alongside this one.
        const anyRowProcessed = (this.editedItem || []).some((row) => row.ccProcessed);
        if (!anyRowProcessed) {
          this.clearCapturedForteResponses();
        }
        // Re-arm the Forte1 (forte-pay) success edge when the clerk targets a DIFFERENT
        // credit row (i.e. a second card). fortePaymentSuscessFlag is a singleton boolean
        // whose only other reset lives in postUpsertTransaction — and that reset is skipped
        // when the clerk cancels the unprocessed-CC confirm to go process the next card.
        // Without re-arming, card 2's success (true->true) is a no-op the parent watcher
        // never sees, so its ccProcessed never flips. Guarded on an index change so a
        // same-row re-blur (after that card already charged) can't clear a live flag.
        if (index !== this.forteActiveIndex) {
          this.setFortePaymentSuccessFlag(false);
        }
      }
      this.forteActiveIndex = index;
      this.setForteIndex(index);
      this.setActiveItemIndex(index);
    },
    isCredit(item, index) {
      return index !== undefined && item && (item.paymentType === 'CREDIT');
    },
    hasEnteredBasics(item) {
      return item && Number(amountToNumber(item.amount)) > 0;
    },
    // SIMPLIFIED: More readable logic
    shouldWarnUnprocessedCC(item, index) {
      // Only show warning if:
      // 1. It's a credit card payment
      // 2. User has entered amount and paidBy
      // 3. Payment has NOT been processed
      // console.info('shouldWarnUnprocessedCC: Checking conditions for item', item);
      return this.isCredit(item, index)
        && this.hasEnteredBasics(item)
        && !item.ccProcessed;
    },
    async fetchForteConfiguration(item) {
      if (this.defaultForteConfig.isRequiredForte) {
        this.renderForteComponentFlag = false;
        await this.fetchForteConfig({
          scope: this.defaultForteConfig.configScope,
          forteAmount: (item.amount || 0).toString(),
        });
        this.$nextTick(() => {
          this.renderForteComponentFlag = true;
        });
      }
    },
    handlePlusClass() {
      if (this.paymentAddIconStatus) return 'addIconClass';
      return '';
    },
    overUnderPayment() {
      this.$emit('overUnderPayClicked');
    },
    async handlePayrix(item, index) {
      if (!this.isPayrix) {
        alert('Payrix is not enabled for this program');
        return;
      }

      const amt = amountToNumber(item.amount);
      if (item.paidBy === '') {
        alert('Please include PAID BY');
        return;
      }
      if (amt && amt > 0) {
        const creditFeePercentage = amountToNumber(this.paymentSettingItem.payrixCreditPercentage);
        const debitFeePercentage = amountToNumber(this.paymentSettingItem.payrixDebitPercentage);
        const debitFeeFlat = amountToNumber(this.paymentSettingItem.payrixDebitFeeFlat);
        const debitAmtLimit = amountToNumber(this.paymentSettingItem.payrixDebitAmtLimit);
        const convenienceFeeCredit = amountToNumber((amt * creditFeePercentage) / 100);
        const totalPlusCreditFee = amountToNumber(amt + convenienceFeeCredit);
        const eCheckFee = amountToNumber(this.paymentSettingItem.payrixEcheckFee);
        const totalPlusEcheckFee = amountToNumber(amt + eCheckFee);
        const ownerName = item.paidBy || '';
        let convenienceFeeDebit = 0;
        if (debitAmtLimit > 0 && amt < debitAmtLimit) {
          convenienceFeeDebit = debitFeeFlat;
        } else {
          convenienceFeeDebit = amountToNumber((amt * debitFeePercentage) / 100);
        }
        const totalPlusDebitFee = amountToNumber(amt + convenienceFeeDebit);
        const payrixPaymentData = {
          totalAmount: amt,
          convenienceFeeCredit,
          totalPlusCreditFee,
          convenienceFeeDebit,
          totalPlusDebitFee,
          creditFeePercentage,
          debitFeePercentage,
          debitFeeFlat,
          eCheckFee,
          totalPlusEcheckFee,
          ownerName,
        };
        try {
          await this.setPaymentContext('TAX');
          await this.setPayrixPaymentType(item.paymentType);
          await this.setPayrixPaymentData(payrixPaymentData);
          await this.$store.dispatch('common/payrixPayment/setTaxCartContents', this.taxPaymentRecord.taxDetails);
          await this.setActiveItemIndex(index);
          // Starting a fresh payment's FIRST card? Clear any captured CC records left over
          // from a prior (e.g. abandoned) payment so they can't leak onto this one. Once a
          // card has been processed on this payment, keep the accumulator so earlier cards'
          // captures survive to be saved alongside this one.
          const anyRowProcessed = (this.editedItem || []).some((row) => row.ccProcessed);
          if (!anyRowProcessed) {
            await this.clearCapturedCCPayments();
          }
          // Re-arm the success edge for THIS card BEFORE opening the dialog. paymentSuccessFlag
          // is a singleton boolean; without this reset a second card's success (true->true) is a
          // no-op that the edge-triggered payrixSuccessFlag watcher never sees, so that row's
          // ccProcessed never flips. Resetting to false here guarantees a fresh false->true edge
          // for every card. The payrixSuccessFlag watcher's `if (!newVal) return;` guard makes
          // this false event inert.
          await this.setPaymentSuccessFlag({ flag: false, transactionId: '' });
          await this.toggleDialog(true);
        } catch (error) {
          console.error('handlePayrix: error during async operations', error);
          throw error;
        }
      } else {
        alert('Please enter a valid amount');
      }
    },
    async handleForte2(item, index) {
      if (!this.isForte2) {
        alert('Forte2 is not enabled for this program');
        return;
      }
      if (item.paidBy === '') {
        alert('Please include PAID BY');
        return;
      }
      const amt = amountToNumber(item.amount);
      if (!amt || amt <= 0) {
        alert('Please enter a valid amount');
        return;
      }
      const creditFeePercentage = amountToNumber(this.paymentSettingItem.forte2CreditPercentage);
      const debitFeePercentage = amountToNumber(this.paymentSettingItem.forte2DebitPercentage);
      const forte2PaymentData = {
        totalAmount: amt,
        creditFeePercentage,
        debitFeePercentage,
        // Flat eCheck fee ($) from the rate plan. amountToNumber backfills a
        // missing/empty key to 0, so pre-eCheck-fee configs stay fee-free.
        forte2EcheckFee: amountToNumber(this.paymentSettingItem.forte2EcheckFee),
        ownerName: item.paidBy || '',
        // config the dialog needs (Forte.js + backend REST creds).
        // Fee/login/CDN come from paymentConfig; gateway REST creds from odSettingItem.
        forte2CdnUrl: this.paymentSettingItem.forte2CdnUrl,
        forte2ApiLoginId: this.paymentSettingItem.forte2ApiLoginId,
        forte2BaseUrl: this.odSettingItem.forte2BaseUrl,
        forte2OrgId: this.odSettingItem.forte2OrgId,
        forte2AuthOrgId: this.odSettingItem.forte2AuthOrgId,
        forte2LocId: this.odSettingItem.forte2LocId,
        forte2ApiAccessId: this.odSettingItem.forte2ApiAccessId,
        forte2ApiSecureKey: this.odSettingItem.forte2ApiSecureKey,
      };
      try {
        // Tender comes from the row (CREDIT or ECHECK) and drives which block the dialog renders.
        await this.setForte2PaymentType(item.paymentType);
        await this.setForte2PaymentData(forte2PaymentData);
        // track the row so the forte2 success watcher targets the correct paymentDetails entry
        await this.setForte2ActiveItemIndex(index);
        // Starting a fresh payment's FIRST card? Drop any captures left over from a prior
        // (e.g. abandoned) payment so they can't leak onto this one. Once a card/eCheck on this
        // payment is processed, keep them so earlier charges' captures survive to save time.
        const anyRowProcessed = (this.editedItem || []).some((row) => row.ccProcessed);
        if (!anyRowProcessed) {
          await this.clearCapturedForte2Payments();
        }
        // Re-arm the success edge for THIS charge. forte2 paymentSuccessFlag is a latched
        // singleton; without this reset a second charge's success (true->true) is a no-op the
        // edge-triggered forte2SuccessFlag watcher never sees, so that row's ccProcessed never
        // flips. Resetting to false guarantees a fresh false->true edge per charge. The watcher's
        // `if (!newVal) return;` guard makes this false event inert.
        await this.setForte2PaymentSuccessFlag({ flag: false, transactionId: '' });
        await this.toggleForte2Dialog(true);
      } catch (error) {
        console.error('handleForte2: error during async operations', error);
        throw error;
      }
    },
    handleForte(item) {
      console.info('handleForte', item);
    },

    highlightTypeFunc() {
      setTimeout(() => {
        if (this.$refs && this.$refs.paymentTypeRef.length) {
          const slectedIndex = this.$refs.paymentTypeRef.length - 1 || 0;
          this.$refs.paymentTypeRef[slectedIndex].focus();
        }
      }, 100);
    },
  },
};
</script>
